import { createFileRoute } from "@tanstack/react-router";
import PrivacyWebsite from "@/pages/PrivacyWebsite";

export const Route = createFileRoute("/privacy-website")({
  head: () => ({
    meta: [
      { title: "Privacybeleid Website – De Hussel App" },
      { name: "description", content: "Privacybeleid voor het gebruik van de website dehusselapp.nl. Informatie over cookies, analytics en gegevensverwerking." },
      { property: "og:title", content: "Privacybeleid Website – De Hussel App" },
      { property: "og:description", content: "Privacybeleid voor het gebruik van de website dehusselapp.nl. Informatie over cookies, analytics en gegevensverwerking." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/privacy-website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/privacy-website" }],
  }),
  component: PrivacyWebsite,
});
